module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/efd36fc8af90b031c417299418dda296.svg";